import React from 'react'

const PageNotFound = () => {

    return (<>
        <div className='h-screen bg-white'>
            <div className="flex justify-center items-center">
                <div className='mt-11 flex flex-col items-center border-4 border-primary p-8 text-warning shadow-5'>
                    <h1 >404 Page Not Found</h1>
                    <h4>The Page you are looking for is no longer available.</h4>
                </div>
            </div>
        </div>
    </>)
}

export default PageNotFound